import React from 'react';
import classNames from 'classnames';
import styles from '../assets/incentive-actions.module.scss';
import user from '../../../../../../../services/user-auth';
import UserRole from '../../../../../../../enumerables/user-role';
import DeleteIncentiveAction from './DeleteIncentiveAction';

const IncentiveActionsColumn: React.FunctionComponent<any> = ({
    updateState,
    setUpdateState,
    cell: {
        row: { original },
    },
}: any) => {
    return (
        <div className={`${classNames(styles.actions)} `}>
            {original.status !== 3 && user.getRoles().includes(UserRole.ROLE_ADMIN) && (
                <div className={'d-flex'}>
                    <DeleteIncentiveAction data={original} />
                </div>
            )}
        </div>
    );
};

export default IncentiveActionsColumn;
